import { forwardRef } from "react";


// Custom styles for MDInput
import MDInputRoot from "components/MDInput/MDInputRoot";

const MDInput = forwardRef(({ error = false, success = false, disabled = false, ...rest }, ref) => {
  return <MDInputRoot {...rest} ref={ref} ownerState={{ error, success, disabled }} />;
});


export default MDInput;
